/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const GuaranteeProgramListPage = lazyLoad(
  () => import('./index'),
  module => module.GuaranteeProgramListPage,
);
